import styled from '@emotion/styled';
import xw from 'xwind';

import CheckListItem from './CheckListItem';

const Title = styled.h2(
  xw`
    font-bold text-xl 
    text-center text-active 
    mb-10 md[text-2xl mb-20] relative
  `,
);

type CheckListProps = {
  title: string;
  items: any[];
  linkId: string;
};

const CheckListSection = ({
  title,
  items,
  linkId,
}: CheckListProps): JSX.Element => {
  return (
    <div id={linkId} css={xw`pb-16 md:pb-28`}>
      <Title>{title}</Title>
      {items.map((i) => (
        <CheckListItem key={i.id} {...i} />
      ))}
    </div>
  );
};

export default CheckListSection;
